import type { ReactNode } from 'react';
import { Logo } from '../components/Logo';

export function StationShell({ right, dark, children }: { right?: ReactNode; dark?: boolean; children: ReactNode }) {
  return (
    <div className={`phone${dark ? ' dark' : ''}`}>
      <div className="phone-bar">
        <Logo size={24} />
        <span className="display" style={{ fontSize: 20, letterSpacing: '0.04em' }}>
          Splitline
        </span>
        <span style={{ marginLeft: 'auto', fontSize: 14, color: 'var(--bar-muted)' }}>{right}</span>
      </div>
      {children}
    </div>
  );
}
